import React from 'react';
import { connect } from 'react-redux';
import OrderPanel from '../common/OrderPanel/OrderPanel';
import PlaceOrder from './components/PlaceOrder';
import { dashboardData } from '../dashboard/reducer';
import {
  loyaltyDiscount,
  giftCardDiscount,
  payCOD,
  payMealPlan as payMealPlanAction,
} from './actions';
import NotFound from '../common/NotFound';
import {
  removeItemFromBag,
  updateTipPrice,
  modeOfOrder,
  checkoutDiningChanged,
  goToCheckout,
  showMobileSidebar,
  checkoutDeliveryPlaceChanged,
} from '../dashboard/actions';
import { GetOrderType, parsePrice, GetCartItems } from '../../lib/helper.js';
import DiningChangedPopup from './components/DiningChangedPopup.jsx';
import _ from 'lodash';
import { getItemTaxes } from '../../api/api';
import Loading from '../common/Loading';

class Checkout extends React.Component {
  constructor(props) {
    super(props);
    let currentRoute = this.props.location.pathname.split('/')[1].toLowerCase();
    if (
      this.props.dashboardData.previousRoute !== false &&
      this.props.dashboardData.previousRoute.toLowerCase() !== currentRoute
    ) {
      this.props.dashboardData.orderItemsList = [];
    }

    this.state = {
      updateCurrentItem: false,
      updatedOrderItemIndex: 0,
      tip: 0.0,
      tipType: this.props.dashboardData.tipType,
      tipPercent: 0,
      isValisDeliveryAddress: true,
      openCheckout: true,
      onChangeItemlist: [],
      diningPopup: false,
      orderTypeName: GetOrderType(this.props.dashboardData.modeOfOrder, {
        pickup: 'pickup',
        delivery: 'delivery',
        dine_in: 'dine-in',
      }),
      orderType: this.props.dashboardData.modeOfOrder,
      payMode: '',
      loading: true,
    };
    this.handleDiningOrderTypeChanged = this.handleDiningOrderTypeChanged.bind(
      this
    );
  }

  componentDidMount() {
    this.props.dispatch(checkoutDeliveryPlaceChanged(true));
    this.setState({
      loading: false,
    });

    if (
      this.props.dashboardData.showMobileSidebar === true &&
      window.innerWidth <= 768
    ) {
      this.props.dispatch(showMobileSidebar(false));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(checkoutDeliveryPlaceChanged(false));
  }

  updateTip(tip, tipType, tipPercent) {
    this.setState({ tip: tip, tipType: tipType, tipPercent: tipPercent });
    this.props.dispatch(updateTipPrice(tip, tipType, tipPercent));
  }

  validateDeliveryAddress(isValid) {
    this.setState({ isValisDeliveryAddress: isValid });
  }

  changeDiningOption(mode) {
    const _cartItems = this.props.dashboardData.orderItemsList;
    let orderTypeName = GetOrderType(mode);

    if (_cartItems.length > 0) {
      let itemNotInList = [];
      _cartItems.forEach((item, index) => {
        if (
          item &&
          item.dining_option
            .toLowerCase()
            .indexOf(orderTypeName.toLowerCase()) === -1
        ) {
          item.key = index;
          itemNotInList.push(item);
        }
      });

      if (itemNotInList.length === 0) {
        this.handleDiningOrderTypeChanged(mode, false);
      } else {
        this.setState({
          diningPopup: true,
          onChangeItemlist: itemNotInList,
          orderType: mode,
        });
      }
    } else {
      this.props.dispatch(modeOfOrder(mode));
    }
  }

  onDiningchangedCancel() {
    this.setState({
      diningPopup: false,
      onChangeItemlist: [],
    });
  }

  switchModal(clickedItem) {
    this.setState({ currentItemClicked: clickedItem, openModal: true });
  }

  updateCartItem(clickedItem, orderItemIndex) {
    this.setState({
      currentItemClicked: clickedItem,
      openModal: true,
      updateCurrentItem: true,
      updatedOrderItemIndex: orderItemIndex,
    });
    this.openModifierClosePlaceOrder();
  }

  openModifierClosePlaceOrder() {
    this.setState({ openCheckout: !this.state.openCheckout });
  }

  removeOrderItem(itemIndex) {
    let tempArray = [...this.props.dashboardData.orderItemsList];
    tempArray.splice(itemIndex, 1);
    let totalCartPrice = 0;
    tempArray.map(item => {
      totalCartPrice =
        totalCartPrice + parseFloat(parsePrice(item.price, true));
      return totalCartPrice;
    });
    this.props.dispatch(removeItemFromBag(tempArray, totalCartPrice));
  }

  removeAllItems() {
    this.props.dispatch(removeItemFromBag([]));
  }

  loyaltyDiscount(data) {
    this.props.dispatch(loyaltyDiscount(data));
  }

  payCOD(orderDetails, callBackAfterPayment) {
    this.props
      .dispatch(payCOD(orderDetails, this.props.tokenId, this.props.jwt))
      .then(response => {
        callBackAfterPayment(response);
      });
  }

  payMealPlan(orderDetails, callBackAfterPayment) {
    this.props.dispatch(
      payMealPlanAction(
        orderDetails,
        this.props.tokenId,
        this.props.jwt,
        callBackAfterPayment
      )
    );
  }

  giftCardDiscount(data) {
    this.props.dispatch(giftCardDiscount(data));
  }

  handleDiningOrderTypeChanged(mode, reloadTaxes) {
    reloadTaxes = reloadTaxes === false ? false : true;
    const { jwt, tokenId } = this.props;
    this.props.dispatch(checkoutDiningChanged().bind(this)).then(() => {
      this.props.dispatch(modeOfOrder(mode));
      if (reloadTaxes === true) {
        getItemTaxes({
          cart_contents: GetCartItems([
            ...this.props.dashboardData.orderItemsList,
          ]),
          dataname: this.props.dashboardData.dataName,
          tokenId,
          jwt,
        }).then(response => {
          this.props.dispatch(goToCheckout(response.data.DataResponse));
        });
      }
    });
  }

  changeDiningOptionContinue(mode) {
    if (this.state.onChangeItemlist.length > 0) {
      let cartItems = _.pullAllWith(
        [...this.props.dashboardData.orderItemsList],
        this.state.onChangeItemlist,
        !_.isEqual
      );

      let totalCartPrice = _.sumBy(cartItems, function(item) {
        return parseFloat(parsePrice(item.price, true));
      });

      this.props
        .dispatch(removeItemFromBag(cartItems, totalCartPrice))
        .then(() => {
          this.setState({
            diningPopup: false,
          });
          this.handleDiningOrderTypeChanged(this.state.orderType);
        });
    }
  }

  getChangedDinning() {
    return GetOrderType(this.state.orderType);
  }

  setPayModeState(payMode) {
    this.setState({
      payMode: payMode,
    });
  }

  render() {
    var dineInOption;
    var split_order_type = [];
    if (
      this.props.dashboardData &&
      this.props.dashboardData.merchantDetails &&
      this.props.dashboardData.merchantDetails.ltg_dine_in_option
    ) {
      dineInOption = this.props.dashboardData.merchantDetails.ltg_dine_in_option.toLowerCase();
      split_order_type = dineInOption.split(',');
    }

    let onDiningchanged = this.state.diningPopup ? (
      <DiningChangedPopup
        onDiningchangedCancel={() => this.onDiningchangedCancel()}
        changeDiningOptionContinue={() => this.changeDiningOptionContinue()}
        orderType={() => this.getChangedDinning()}
        items={this.state.onChangeItemlist}
        show={true}
      />
    ) : null;

    return (
      <div>
        {this.state.loading ? <Loading /> : null}
        {(this.props.authenticated || this.props.guest) &&
        !this.state.loading ? (
          <div>
            {onDiningchanged}
            <PlaceOrder
              changeDiningOption={mode => this.changeDiningOption(mode)}
              orderItems={this.props.dashboardData.orderItemsList}
              cartTotal={this.props.dashboardData.cartPice}
              updateTip={(tip, tipType, tipPercent) =>
                this.updateTip(tip, tipType, tipPercent)
              }
              validateDeliveryAddress={isValid =>
                this.validateDeliveryAddress(isValid)
              }
              loyaltyDiscount={data => this.loyaltyDiscount(data)}
              payCOD={(orderDetails, callBackAfterPayment) =>
                this.payCOD(orderDetails, callBackAfterPayment)
              }
              payMealPlan={(orderDetails, callBackAfterPayment) =>
                this.payMealPlan(orderDetails, callBackAfterPayment)
              }
              giftCardDiscount={data => this.giftCardDiscount(data)}
              rname={this.props.params.rname}
              orderTypeSplit={split_order_type}
              setPayModeState={mode => this.setPayModeState(mode)}
            />
            <OrderPanel
              orderPanelClass="sideBar hidden-md-down"
              selectedLocationAddress={
                this.props.dashboardData.locationDetails.selectedLocationAddress
              }
              selectedLocationAddressId={
                this.props.dashboardData.locationDetails
                  .selectedLocationAddressId
              }
              modeOfOrder={this.props.dashboardData.modeOfOrder}
              updateCartItem={(clickedItem, orderItemIndex) => {
                this.updateCartItem(clickedItem, orderItemIndex);
              }}
              switchModal={clickedItem => this.switchModal(clickedItem)}
              removeOrderItem={itemIndex => this.removeOrderItem(itemIndex)}
              removeAllItems={() => this.removeAllItems()}
              orderItems={this.props.dashboardData.orderItemsList}
              orderPanelFromDashboard="false"
              deliveryTime={
                this.props.dashboardData.locationDetails.deliveryTime
              }
              DeliveryFee={
                this.props.dashboardData.locationDetails.delivery_fees
                  ? this.props.dashboardData.locationDetails.delivery_fees
                  : 0
              }
              rname={this.props.params.rname}
              deliveryAddress={
                this.props.dashboardData.locationDetails.selectedLocationAddress
              }
              tip={this.state.tip}
              isValisDeliveryAddress={this.state.isValisDeliveryAddress}
              payMode={this.state.payMode}
            />
          </div>
        ) : null}
        {!this.props.authenticated &&
        !this.props.guest &&
        !this.state.loading ? (
          <NotFound code="401" message="It looks you are an invalid user" />
        ) : null}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    dashboardData: dashboardData(state),
    authenticated: state.auth.authenticated,
    guest: state.auth.guest,
    tokenId: state.auth.tokenId,
    jwt: state.auth.jwt,
  };
}

export default connect(mapStateToProps)(Checkout);



// WEBPACK FOOTER //
// ./src/views/checkout/Checkout.jsx